module.exports = __webpack_public_path__ + "static/media/20ECE7.f4cfa6d2.jpg";